import { getFormattedOdds } from './formatOdds';
import { publish } from '@wh/message-bus';
import { MB_ADD_TO_SLIP, MB_REMOVE_FROM_SLIP } from '../../consts';
const handleOnSelectionClick = (selectionId, selectionName, selectionsInBetslip, index, deepLinkUrl) => {
    const trimmedId = selectionId.replace('OB_OU', '');
    const data = {
        id: trimmedId,
        analytics: {
            BetListName: [`EpicValueCardCarousel`],
            BetListPosition: [`${index + 1}`],
            FeatureDescription: [`${selectionName}`],
        },
    };
    if (deepLinkUrl) {
        window.location.replace(deepLinkUrl.replace('{{SELECTION_ID}}', trimmedId));
        return;
    }
    if (selectionsInBetslip.includes(trimmedId)) {
        publish(MB_REMOVE_FROM_SLIP, trimmedId);
    }
    else {
        publish(MB_ADD_TO_SLIP, data);
    }
};
const concessionToIconPropsMap = {
    EnhancedOdds: { isEnhanced: true },
    SuperOdds: { isSuperOdds: true },
    FlashOdds: { isFlashOdds: true },
    YourOdds: { isDoubleYourOdds: true },
    DoubleYourOdds: { isDoubleYourOdds: true },
    EpicOdds: { isSuperOdds: true },
    TopPriceGuarantee: { isEnhanced: true },
    TopAcca: { isEnhanced: true },
};
const getSelectionButtonProps = ({ selectionId, oddsFormat, numerator, denominator, selectionsInBetslip, }) => {
    return {
        selectionId,
        formattedOdds: getFormattedOdds(oddsFormat, numerator, denominator),
        isAdded: selectionsInBetslip.includes(selectionId.replace('OB_OU', '')),
    };
};
export const createSelectionButton = ({ concessionName, selectionId, selectionName, oddsFormat, numerator, denominator, selectionsInBetslip, index, deepLinkUrl, }) => {
    const concession = concessionName;
    return Object.assign(Object.assign({}, (concessionToIconPropsMap[concession] || {})), { hideIcon: true, selection: getSelectionButtonProps({ selectionId, oddsFormat, numerator, denominator, selectionsInBetslip }), callback: () => handleOnSelectionClick(selectionId, selectionName, selectionsInBetslip, index, deepLinkUrl) });
};
